// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fc0fe096","498":"ca0f632d","703":"e2a7c01a","787":"a8a7d06d"}[chunkId] + ".chunk.js";
};